import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect } from "react";

export default function Error404() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Error 404"; }, []);

	return <Section center>
		<p>Error 404! Page Not Found</p>
	</Section>;
}